/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  MovementOnFundsReportOperationFundDto,
  MovementOnFundsReportOperationFundDtoFromJSON,
  MovementOnFundsReportOperationFundDtoFromJSONTyped,
  MovementOnFundsReportOperationFundDtoToJSON,
} from "./MovementOnFundsReportOperationFundDto";
import {
  MovementOnFundsReportOperationLoanDtoFromDeferred,
  MovementOnFundsReportOperationLoanDtoFromDeferredFromJSON,
  MovementOnFundsReportOperationLoanDtoFromDeferredFromJSONTyped,
  MovementOnFundsReportOperationLoanDtoFromDeferredToJSON,
} from "./MovementOnFundsReportOperationLoanDtoFromDeferred";
import {
  MovementOnFundsReportOperationLoanDtoFromFund,
  MovementOnFundsReportOperationLoanDtoFromFundFromJSON,
  MovementOnFundsReportOperationLoanDtoFromFundFromJSONTyped,
  MovementOnFundsReportOperationLoanDtoFromFundToJSON,
} from "./MovementOnFundsReportOperationLoanDtoFromFund";

/**
 *
 * @export
 * @interface MovementOnFundsReportFundOperationDtoLoan
 */
export interface MovementOnFundsReportFundOperationDtoLoan {
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoLoan
   */
  id: string;
  /**
   *
   * @type {number}
   * @memberof MovementOnFundsReportFundOperationDtoLoan
   */
  number: number;
  /**
   *
   * @type {Date}
   * @memberof MovementOnFundsReportFundOperationDtoLoan
   */
  createdAt: Date;
  /**
   *
   * @type {MovementOnFundsReportOperationLoanDtoFromDeferred}
   * @memberof MovementOnFundsReportFundOperationDtoLoan
   */
  fromDeferred: MovementOnFundsReportOperationLoanDtoFromDeferred | null;
  /**
   *
   * @type {MovementOnFundsReportOperationLoanDtoFromFund}
   * @memberof MovementOnFundsReportFundOperationDtoLoan
   */
  fromFund: MovementOnFundsReportOperationLoanDtoFromFund | null;
  /**
   *
   * @type {MovementOnFundsReportOperationFundDto}
   * @memberof MovementOnFundsReportFundOperationDtoLoan
   */
  toFund: MovementOnFundsReportOperationFundDto;
  /**
   *
   * @type {Date}
   * @memberof MovementOnFundsReportFundOperationDtoLoan
   */
  returnAt: Date;
  /**
   *
   * @type {string}
   * @memberof MovementOnFundsReportFundOperationDtoLoan
   */
  comment: string;
}

export function MovementOnFundsReportFundOperationDtoLoanFromJSON(
  json: any
): MovementOnFundsReportFundOperationDtoLoan {
  return MovementOnFundsReportFundOperationDtoLoanFromJSONTyped(json, false);
}

export function MovementOnFundsReportFundOperationDtoLoanFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MovementOnFundsReportFundOperationDtoLoan {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    number: json["number"],
    createdAt: new Date(json["createdAt"]),
    fromDeferred: MovementOnFundsReportOperationLoanDtoFromDeferredFromJSON(json["fromDeferred"]),
    fromFund: MovementOnFundsReportOperationLoanDtoFromFundFromJSON(json["fromFund"]),
    toFund: MovementOnFundsReportOperationFundDtoFromJSON(json["toFund"]),
    returnAt: new Date(json["returnAt"]),
    comment: json["comment"],
  };
}

export function MovementOnFundsReportFundOperationDtoLoanToJSON(
  value?: MovementOnFundsReportFundOperationDtoLoan | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    number: value.number,
    createdAt: value.createdAt.toISOString(),
    fromDeferred: MovementOnFundsReportOperationLoanDtoFromDeferredToJSON(value.fromDeferred),
    fromFund: MovementOnFundsReportOperationLoanDtoFromFundToJSON(value.fromFund),
    toFund: MovementOnFundsReportOperationFundDtoToJSON(value.toFund),
    returnAt: value.returnAt.toISOString(),
    comment: value.comment,
  };
}
